import {
  USER_CREATE, USER_CREATE_FAILURE, USER_CREATE_SUCCESS, USER_NEW, USER_NEW_SUCCESS, USER_NEW_FAILURE, USER_SHOPS, USER_SHOPS_SUCCESS, USER_SHOPS_FAILURE, USER_SHOPS_CLEAR, KANA_GET, KANA_GET_SUCCESS, KANA_GET_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    shops: null,
    user_types: null,
    domains: null,
    businessTypes: null,
    joins: null,
    user_name: null,
    users_notify: null
  },
  getters: {
    userShops: state => {
      return state.shops
    },
    userTypes: state => {
      return state.user_types
    },
    userDomains: state => {
      return state.domains
    },
    userBusinessTypes: state => {
      return state.businessTypes
    },
    userJoins: state => {
      return state.joins
    },
    userNameKana: state => {
      return state.user_name
    },
    usersNotify: state => {
      return state.users_notify
    }
  },
  actions: {
    [USER_NEW] ({dispatch, state, commit}, params) {
      dispatch('apiGet', {url: '/master/users/new'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_NEW_FAILURE, res.data)
            } else {
              commit(USER_NEW_SUCCESS, { data: res.data })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/users', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_CREATE_FAILURE, res.data)
            } else {
              commit(USER_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_SHOPS] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/users/shops/' + params.data.departmentId
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_SHOPS_FAILURE, res.data)
            } else {
              commit(USER_SHOPS_SUCCESS, { data: res.data })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_SHOPS_CLEAR] ({dispatch, state, commit}, params) {
      state.shops = null
    },
    [KANA_GET] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/users/kana_get', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(KANA_GET_FAILURE, res.data)
            } else {
              commit(KANA_GET_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [USER_CREATE_FAILURE] (state, data) {
      console.log('USER_CREATE_FAILURE')
      state.users_notify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.users_notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_CREATE_SUCCESS] (state, data) {
      console.log('USER_CREATE_SUCCESS')
      var callback = data.callback
      callback()
    },
    [USER_NEW_FAILURE] (state, data) {
      console.log('USER_NEW_FAILURE')
    },
    [USER_NEW_SUCCESS] (state, data) {
      console.log('USER_NEW_SUCCESS')
      state.shops = data.data.shops.data
      state.user_types = data.data.user_types.data
      state.domains = data.data.domains.data
      state.businessTypes = data.data.business_types.data
      state.joins = data.data.joins.data
    },
    [USER_SHOPS_FAILURE] (state, data) {
      console.log('USER_SHOPS_FAILURE')
    },
    [USER_SHOPS_SUCCESS] (state, data) {
      console.log('USER_SHOPS_SUCCESS')
      state.shops = data.data.data
    },
    [KANA_GET_FAILURE] (state, data) {
      console.log('KANA_GET_FAILURE')
    },
    [KANA_GET_SUCCESS] (state, data) {
      console.log('KANA_GET_SUCCESS')
      state.user_name = data.data
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user-new.js